import App from "@/views/App.vue";

export default [
  {
    path: "/debate",
    name: "roundTable",
    component: App,
    redirect: { name: "roundTableHome" },
    children: [
      {
        path: "/novo-debate",
        name: "newRoundTableHome",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/CreateDebate.vue"),
        meta: {
          displayName: "displayName.newDebate",
          requiresAuth: true,
        },
      },
      {
        path: "/editar-post-debate/:id",
        name: "editPostRoundTable",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/EditPostRoundTable.vue"
          ),
        meta: {
          displayName: "displayName.editPost",
          requiresAuth: true,
        },
      },
      {
        path: "/debate/:id",
        name: "roundTableItems",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Debate.vue"),
        meta: {
          displayName: "displayName.debateHome",
          requiresAuth: true,
        },
      },
      {
        path: "/lista-debate",
        name: "roundTableList",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/DebateList.vue"),
        meta: {
          displayName: "displayName.debates",
          requiresAuth: true,
        },
      },
      {
        path: "/novo-post-debate/:id",
        name: "newPostDebate",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewPostDebate.vue"),
        meta: {
          displayName: "displayName.createPublication",
          requiresAuth: true,
        },
      },
      {
        path: "/novo-editar-post-round-table/:id",
        name: "newEditPostRoundTable",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/EditPostRoundTable.vue"
          ),
        meta: {
          displayName: "displayName.editPost",
          requiresAuth: true,
        },
      },
      {
        path: "/editar-debate/:id",
        name: "newEditDebate",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/EditDebate.vue"),
        meta: {
          displayName: "displayName.editDebate",
          requiresAuth: true,
        },
      },
    ],
  },
];
